import { render, staticRenderFns } from "./DocumentMangmentAssembely.vue?vue&type=template&id=02e20fc2&scoped=true&"
import script from "./DocumentMangmentAssembely.vue?vue&type=script&lang=js&"
export * from "./DocumentMangmentAssembely.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMangmentAssembely.vue?vue&type=style&index=0&id=02e20fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e20fc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
